module.exports = __webpack_public_path__ + "img/Ballista64_ua.709142bd.webp";